<app-navbar title="Importy"> </app-navbar>
<!-- <div class="container-1">
    <label for="date">Podaj date od</label>
    <br>
    <input type="date" id="begin" name="begin" [(ngModel)]="data.begin" >
    <br>
    <label for="date">do</label>
    <br>
    <input type="date" id="end" name="end" [(ngModel)]="data.end">
    <br>
    <button type="submit" class="getImport" (click)="submit()">Wykonaj</button>
</div> -->
<div class="col-2">
	<div class="col mb-3">
		<div class="form-floating">
			<input class="form-control" type="date" id="begin" name="begin" [(ngModel)]="data.begin" />
			<label for="begin">Podaj date od</label>
		</div>
	</div>
	<div class="col">
		<div class="form-floating mb-2">
			<input class="form-control" type="date" id="end" name="end" [(ngModel)]="data.end" />
			<label for="end">Podaj date do</label>
		</div>
	</div>
</div>
<div class="col">
	<button class="btn btn-primary" (click)="submit()">Wykonaj</button>
</div>
